









import {Component, Prop, Vue} from 'vue-property-decorator';
import {Dice} from '@/classes/Dice';

@Component
export default class DiceView extends Vue {
    @Prop() protected dice!: Dice;
}
